import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  FormControlLabel,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  TextareaAutosize,
  Tooltip,
  InputLabel,
} from "@material-ui/core";
import { API_URL } from "../../constants/api";
import { apiPost, apiPut, apiRequest } from "../../utils/api_service";
import { ShowToast, toastType } from "../../utils/toast-service";
import { GetEnableProperty, GetPropertyVisibility, PaperComponent } from "../../utils/helper";
import "./tenants.less";
import { IoMdCloseCircleOutline } from "react-icons/io";
import CancelIcon from "@material-ui/icons/Cancel";
import { validateInput } from "../../utils/validations";
import KeyBoardDatePickers from "../common/KeyboardDatePicker/DatePicker";
// import { SECTIONS } from "../../constants/appConstants";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import { SECTIONS } from "../../constants/appConstants";

class AddUpdateTenant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tenantId: 0,
      tenantDetailId: 0,
      tenantName: "",
      powerLeased: 0.0,
      sqFt: 0.0,
      notes: "",
      effectiveFrom: new Date(),
      effectiveTo: null,
      dataCenterList: [],
      selectedPropertyId: 0,
      isCloseSaveConfirm: false,
      usersCount: props?.usersCount,
      serviceLocationValues: [
        { serviceLocationId: 0, suite: "", rack: "", side: "" }
      ],
      getToolTip: props.toolTipData || [],
      createdOn: null,
      modifiedOn: null
    };
  }


  componentDidMount() {
    this.getDataCenterList();
  }

  /**
   * get props on component based on TenantId
   * @param {*} newProps 
   */
  componentWillReceiveProps(newProps) {
    if (newProps.tenantId != this.state.tenantId && newProps.tenantId > 0) {
      this.getTenantById(newProps.tenantId);
    }
    this.setState({ tenantId: newProps.tenantId });
  }

  /**
   * get tenant data by tenant id
   * @param {*} tenantId
   */
  getTenantById = tenantId => {
    const params = {
      tenantId: tenantId,
      dateOffset: moment().utcOffset(),
    };
    apiRequest({ url: API_URL.tenant.GetTenantById, params }).then(
      ({ data: tenant }) => {
        if (tenant) {
          const serviceLocations = tenant.ServiceLocationValues?.map(function(
            data
          ) {
            return {
              serviceLocationId: data.ServiceLocationId,
              suite: data.Suite,
              side: data.Side,
              rack: data.Rack
            };
          });

          let { dataCenterList } = this.state;
          const disabledProperty = GetPropertyVisibility(SECTIONS.ADD_UPDATE_TENANT);
          const notSelectedDisabledProperty = disabledProperty.filter(x=> x !== tenant.PropertyId);
          dataCenterList = dataCenterList.filter(dc => (notSelectedDisabledProperty || []).find(x=> x === dc.propertyID) === undefined);
          this.setState({
            dataCenterList,
            powerLeased: tenant.PowerLeased,
            sqFt: tenant.SqFt,
            tenantName: tenant.TenantName,
            notes: tenant.Notes,
            selectedPropertyId: tenant.PropertyId,
            effectiveFrom: tenant.EffectiveFrom || new Date(),
            effectiveTo: tenant.EffectiveTo ? tenant.EffectiveTo : null,
            tenantDetailId: tenant.TenantDetailId,
            serviceLocationValues: serviceLocations,
            createdOn: tenant.CreatedOn,
            modifiedOn: tenant.ModifiedOn

          });
        } else {
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
        }
      }
    );
  };

  /**
   * call on submit button
   * @param {*} isAddContact
   */
  onSubmit = (isAddContact = false) => {
    const {
      tenantId,
      tenantDetailId,
      tenantName,
      powerLeased,
      sqFt,
      notes,
      selectedPropertyId,
      effectiveFrom,
      effectiveTo,
      serviceLocationValues
    } = this.state;

    if (this.state.tenantId > 0) {
      this.updateTenant({
        tenantId: tenantId,
        tenantDetailId: tenantDetailId,
        propertyId: selectedPropertyId,
        tenantName: tenantName?.trim(),
        powerLeased: powerLeased,
        sqFt: sqFt,
        notes: notes?.trim(),
        status: 1,
        effectiveFrom: effectiveFrom ? effectiveFrom : new Date(),
        effectiveTo: effectiveTo ? effectiveTo : null,
        serviceLocationValues: serviceLocationValues.filter(
          f => f.suite && f.suite != ""
        )
      });
    } else {
      this.addTenant(
        {
          tenantId,
          propertyId: selectedPropertyId,
          tenantName: tenantName?.trim(),
          powerLeased: powerLeased,
          sqFt: sqFt,
          notes: notes?.trim(),
          effectiveFrom: effectiveFrom ? effectiveFrom : new Date(),
          effectiveTo: effectiveTo ? effectiveTo : null,
          serviceLocationValues: serviceLocationValues.filter(
            f => f.suite && f.suite != ""
          )
        },
        isAddContact
      );
    }
  };

  /**
   * add tenant api to save tenant data
   * @param {*} params
   * @param {*} isAddContact
   */
  addTenant = (params, isAddContact = false) => {
    this.setState({ isCloseSaveConfirm: false });
    apiPost({
      url: API_URL.tenant.AddTenant,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (!success || response?.success == 0) {
        ShowToast(response.message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success == true) {
        ShowToast("Tenant added Successfully", toastType.SUCCESS, 5000, 200);
        if (response.data.TenantId && isAddContact) {
          this.props.history.push({
            pathname: "/tenantContact",
            aboutProps: {
              TenantId: response.data.TenantId,
              TenantName: response.data.TenantName,
              PropertyId: response.data.PropertyId,
              isOpenDefaultAdd: true,
              isActiveTenant: true,
              tenantEffectiveToDate: params.effectiveTo
            }
          });
        } else {
          this.props.onSave(true);
        }
      } else {
        this.props.onSave(false);
      }
    });
  };

  /**
   * update tenant api to update tenant data
   * @param {*} params
   */
  updateTenant = params => {
    apiPut({
      url: API_URL.tenant.UpdateTenant,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (!success || response?.success == 0) {
        ShowToast(response.message, toastType.ERROR, 5000, 200);
        return;
      }
      if (success == true) {
        ShowToast("Tenant Updated Successfully", toastType.SUCCESS, 5000, 200);
        this.props.onSave(true);
      } else {
        this.props.onSave(false);
      }
    });
  };

  /**
   * call on submit confirm button
   * @returns
   */
  onSubmitConfirm = () => {
    const {
      tenantId,
      tenantDetailId,
      tenantName,
      powerLeased,
      sqFt,
      notes,
      effectiveFrom,
      effectiveTo,
      selectedPropertyId,
      serviceLocationValues
    } = this.state;

    const tenantEffectiveFrom = effectiveFrom
      ? new Date(effectiveFrom).getMonth() +
        1 +
        "/" +
        new Date(effectiveFrom).getDate() +
        "/" +
        new Date(effectiveFrom).getFullYear()
      : effectiveFrom;

    const tenantEffectiveTo = effectiveTo
      ? new Date(effectiveTo).getMonth() +
        1 +
        "/" +
        new Date(effectiveTo).getDate() +
        "/" +
        new Date(effectiveTo).getFullYear()
      : effectiveTo;

    const tenantBody = {
      tenantId: tenantId,
      tenantDetailId: tenantDetailId,
      propertyId: selectedPropertyId,
      tenantName: tenantName?.trim(),
      powerLeased: powerLeased.toString(),
      sqFt: sqFt.toString(),
      notes: notes?.trim(),
      status: 1,
      effectiveFrom: tenantEffectiveFrom,
      effectiveTo: tenantEffectiveTo,
      serviceLocationValues: serviceLocationValues.filter(
        f => f.suite && f.suite != ""
      )
    };

    const tenantValidation = [
      {
        valueKey: "tenantName",
        type: "text",
        isRequired: true,
        fieldsName: "Tenant Name"
      },
      {
        valueKey: "sqFt",
        type: "number",
        isRequired: true,
        fieldsName: "Square Feet"
      },
      {
        valueKey: "powerLeased",
        type: "number",
        isRequired: true,
        fieldsName: "Power Leased"
      },
      {
        valueKey: "effectiveFrom",
        type: "date",
        isRequired: true,
        fieldsName: "Effective from"
      },
      {
        valueKey: "effectiveTo",
        type: "date",
        isRequired: false,
        fieldsName: "Effective to"
      },
      {
        valueKey: "propertyId",
        type: "text",
        isRequired: true,
        fieldsName: "Data Center"
      },
      {
        valueKey: "serviceLocationValues",
        type: "array",
        isRequired: true,
        fieldsName: "Service Location"
      }
    ];

    if (validateInput(tenantBody, tenantValidation)) {
      if (effectiveTo) {
        const fromDate = new Date(
          new Date(effectiveFrom).getFullYear(),
          new Date(effectiveFrom).getMonth(),
          new Date(effectiveFrom).getDate()
        );

        const toDate = new Date(
          new Date(effectiveTo).getFullYear(),
          new Date(effectiveTo).getMonth(),
          new Date(effectiveTo).getDate()
        );

        if (toDate < fromDate) {
          ShowToast(
            <>
              <b>{"Invalid Data: "} </b>
              <br />{" "}
              {
                "Effective To Date can not be less that Effective From Date"
              }{" "}
            </>,
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      }

      if (tenantId > 0) {
        this.onSubmit();
      } else {
        this.setState({ isCloseSaveConfirm: true });
      }
    }
  };

  /**
   * call on textBox control
   * @param {*} i
   * @param {*} e
   */
  handleServiceLocationChange(i, e) {
    const {serviceLocationValues} = this.state
    const formValues = serviceLocationValues;
    formValues[i][e.target.name] = e.target.value;
    this.setState({ serviceLocationValues: formValues });
  }

  /**
   * call on textBox control
   * @param {*} i
   * @param {*} e
   */
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**
   * call on number text field
   * @param {*} e
   */
  handleNumberChange = e => {
    if (e.target.value.length <= 15) {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  /**
   * call on float number text field
   * @param {*} e
   */
  handleFloatChange = e => {
    if (e.target.value.length <= 15) {
      if (Math.floor(e.target.value) !== e.target.value) {
        const decimalPlaceCount =
          e.target.value && e.target.value.length > 0
            ? e.target.value.toString().split(".")[1]?.length || 0
            : 0;
        if (decimalPlaceCount <= 1) {
          this.setState({ [e.target.name]: e.target.value });
        }
      }
    }
  };

  /**
   * get master data list of data center
   */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: dataCenterList }) => {
        const  { tenantId } = this.state;
        this.setState({
          dataCenterList: tenantId == 0 ? GetEnableProperty((dataCenterList || []), SECTIONS.ADD_UPDATE_TENANT ) : dataCenterList
        });

        if (this.state.tenantId == 0) {
          this.setState({
            selectedPropertyId: dataCenterList.slice(0, 1).propertyID
          });
        }
      }
    );
  };

  /**
   * call on select dropdown
   * @param {*} id
   */
  onPropertySelect = id => {
    this.setState({ selectedPropertyId: id });
  };

  /**
   * call on add service location
   */
  addServiceLocationFields() {
    const {serviceLocationValues} = this.state

    this.setState({
      serviceLocationValues: [
        ...serviceLocationValues,
        { serviceLocationId: 0, suite: "", side: "", rack: "" }
      ]
    });
  }

  /**
   * call on remove service location
   * @param {*} i
   */
  removeServiceLocationFields(i) {
    const {serviceLocationValues} = this.state
    const formValues = serviceLocationValues;
    formValues.splice(i, 1);
    this.setState({ serviceLocationValues: formValues });
  }

  render() {
    const {
      isCloseSaveConfirm,
      usersCount,
      tenantId,
      effectiveFrom,
      effectiveTo,
      serviceLocationValues,
      createdOn,
      modifiedOn
      
    } = this.state;

    const createdDateTime = createdOn
          ? moment(createdOn).format("MM/DD/YYYY hh:mm A")
          : moment(new Date()).format("MM/DD/YYYY hh:mm A");

    const modifiedDateTime = modifiedOn
          ? moment(modifiedOn).format("MM/DD/YYYY hh:mm A")
          : null;
    const disableDataCenter =
      tenantId == 0
        ? false
        : tenantId > 0 && (usersCount || 0) > 0
        ? true
        : false;

    return (
      <div>
        <Dialog
          open={this.props.isOpen || false}
          onClose={() => this.props.onClose(false)}
          PaperComponent={PaperComponent}
          fullWidth
          maxWidth={"md"}
          className={"addUpdateTenants"}
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {this.props.tenantId > 0 ? "Edit Tenant" : "Add Tenant"}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.props.onClose(false)}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>

          <DialogContent>
            <Box
              component={"form"}
              border={0}
              borderColor={"grey.500"}
              borderRadius={1}
              noValidate
              autoComplete={"off"}
              className={"tenantTable"}
            >
              <div className={"row"}>
                <div className={"col-xs-4 col-md-4 col-lg-4"}>
                  <FormLabel component={"legend"} className={"legend-text-label"} size={"small"} id={"createdOn"}>
                     {"Created On :"}{" "}
                      { createdDateTime ? (
                        createdDateTime
                      ) : null}
                  </FormLabel>
                </div>
                {
                  <div className={"col-xs-4 col-md-4 col-lg-4"}>
                    <FormLabel component={"legend"} className={"legend-text-label"} size={"small"} id={"modifiedOn"}>
                        {"Modified On :"}{" "}
                        { modifiedDateTime ? (
                          modifiedDateTime
                        ) : null}
                    </FormLabel>                   
                  </div>
                }
              </div>
              &nbsp; &nbsp;
              <div className={"row"}>
              
                <div className={"col-xs-4"}>
                  <TextFieldWithToolTip
                    id={"tenantName"}
                    txtName={"tenantName"}
                    isRequired
                    labelHeading={"Tenant Name"}
                    value={this.state.tenantName || ""}
                    onChange={this.handleChange}
                    inProps
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Tenant Name"
                      )?.Tooltip
                    }
                    // inputProps={{
                    //   maxLength: 250,
                    // }}
                  />
                </div>
                <div className={"col-xs-4"}>
                  <TextFieldWithToolTip
                    id={"powerLeased"}
                    txtName={"powerLeased"}
                    isRequired
                    labelHeading={"Power Leased kW"}
                    type
                    value={this.state.powerLeased}
                    onChange={this.handleFloatChange}
                    onKeyDown={e =>
                      (e.keyCode === 69 ||
                        e.keyCode === 187 ||
                        e.keyCode === 189) &&
                      e.preventDefault()}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Power Leased kW"
                      )?.Tooltip
                    }
                  />
                </div>
                <div className={"col-xs-4"}>
                  <TextFieldWithToolTip
                    id={"sqFt"}
                    txtName={"sqFt"}
                    isRequired
                    labelHeading={"Sq Ft Leased"}
                    type
                    value={this.state.sqFt}
                    onChange={this.handleNumberChange}
                    onKeyDown={e =>
                      (e.keyCode === 69 ||
                        e.keyCode === 187 ||
                        e.keyCode === 189 ||
                        e.keyCode === 190) &&
                      e.preventDefault()}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Sq Ft Leased"
                      )?.Tooltip
                    }
                  />
                </div>
              </div>
              <div className={"row bottom-xs"}>
                <div className={"col-xs-4"}>
                  <KeyBoardDatePickers
                    id={"effectiveFrom"}
                    valueDate={effectiveFrom}
                    label={"Effective From"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Effective From"
                      )?.Tooltip
                    }
                    format={"MM/DD/yyyy"}
                    required
                    handleChange={date =>
                      this.setState({ effectiveFrom: date })}
                  />
                </div>
                <div className={"col-xs-4"}>
                  <KeyBoardDatePickers
                    id={"effectiveTo"}
                    valueDate={effectiveTo}
                    label={"Effective To"}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Effective To"
                      )?.Tooltip
                    }
                    format={"MM/DD/yyyy"}
                    minDate={effectiveFrom || "1/1/1700"}
                    handleChange={date => this.setState({ effectiveTo: date })}
                  />
                </div>
                <div className={"col-xs-4"}>
                  <FormControl fullWidth className={"dropdown-select"}>
                    <InputLabelWithToolTip
                      className={"compLabel"}
                      id={"dataCenter-list"}
                      isRequired
                      labelHeading={"Data Center"}
                      toolTip={
                        this.state.getToolTip?.find(
                          b => b.UiColumnName == "Data Center"
                        )?.Tooltip
                      }
                    />
                    {/* <InputLabel id="dataCenter-list">Data Center * </InputLabel> */}
                    <Select
                      fullWidth
                      labelId={"dataCenter-list"}
                      id={"dataCenter-list-select"}
                      label={"DataCenter"}
                      value={this.state.selectedPropertyId}
                      onChange={e => this.onPropertySelect(e.target.value)}
                      disabled={disableDataCenter}
                    >
                      {(this.state.dataCenterList || []).map((item, index) => (
                        <MenuItem
                          key={"dcList" + index}
                          value={item.propertyID}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div
                className={"row"}
                style={{ marginTop: "10px", padding: "6px" }}
              >
                <div className={"col-xs-12"}>
                  <FormControl component={"fieldset"}>
                    <FormLabel component={"legend"} className={"legend-text"}>
                      {"Service Location\r"}
                    </FormLabel>
                  </FormControl>
                </div>
              </div>
              {
                <div className={"row col-xs-12"} style={{ padding: "0px" }}>
                  <Tooltip title={"Add"}>
                    <IconButton
                      aria-label={"Add"}
                      className={"action-button"}
                      size={"small"}
                      onClick={() => this.addServiceLocationFields()}
                      style={{ marginLeft: "0.4rem !important" }}
                    >
                      <AddIcon fontSize={"small"} size={"small"} />
                      <span className={"tool-icon-text"}>{"Add"}</span>
                    </IconButton>
                  </Tooltip>
                </div>
              }
              {serviceLocationValues &&
                serviceLocationValues.map((element, index) => (
                  <div className={"row col-xs-12"} style={{ padding: "0px" }}>
                    <div className={"col-xs-3"}>
                      <TextFieldWithToolTip
                        id={"suite"}
                        txtName={"suite"}
                        labelHeading={"Suite"}
                        //type="text"
                        isRequired
                        //variant="standard"
                        value={element.suite || ""}
                        onChange={e =>
                          this.handleServiceLocationChange(index, e)}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == "Suite"
                          )?.Tooltip
                        }
                        disabled={element.serviceLocationId > 0}                        
                      />
                    </div>
                    <div className={"col-xs-3"}>
                      <TextFieldWithToolTip
                        id={"side"}
                        txtName={"side"}
                        labelHeading={"Row"}
                        value={element.side || ""}
                        onChange={e =>
                          this.handleServiceLocationChange(index, e)}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == "Row"
                          )?.Tooltip
                        }
                      />
                    </div>
                    <div className={"col-xs-3"}>
                      <TextFieldWithToolTip
                        id={"rack"}
                        txtName={"rack"}
                        labelHeading={"Rack"}
                        //type="text"
                        value={element.rack || ""}
                        onChange={e =>
                          this.handleServiceLocationChange(index, e)}
                        toolTip={
                          this.state.getToolTip?.find(
                            b => b.UiColumnName == "Rack"
                          )?.Tooltip
                        }
                      />
                    </div>
                    <div className={"col-xs-3"}>
                      <Tooltip title={element.serviceLocationId > 0 ? "Delete" :"Cancel"}>
                        <IconButton
                          aria-label={"Cancel Row"}
                          size={"small"}
                          onClick={() =>
                            this.removeServiceLocationFields(index)}
                          className={"center-button"}
                        >
                          {element.serviceLocationId > 0 ? <DeleteIcon fontSize={"small"} size={"small"} /> :
                          <CancelIcon fontSize={"small"} size={"small"} />}
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                ))}
              <div className={"row"}>
                <div className={"col-xs-12"} style={{ padding: "0px" }}>
                  <InputLabelWithToolTip
                    className={"notesLabel"}
                    id={"notes"}
                    labelHeading={"Notes"}
                    disabled={false}
                    toolTip={
                      this.state.getToolTip?.find(
                        b => b.UiColumnName == "Notes"
                      )?.Tooltip
                    }
                  />
                  <TextareaAutosize
                    padding={"0px"}
                    id={"notes"}
                    name={"notes"}
                    label={"Notes"}
                    placeholder={"Notes"}
                    type={"text"}
                    value={this.state.notes || ""}
                    variant={"standard"}
                    onChange={this.handleChange}
                    rowsMin={4}
                    rowsMax={4}
                    className={"multiline-tenant-text-box"}
                  />
                </div>
              </div>
            </Box>
          </DialogContent>
          <DialogActions style={{ paddingRight: "24px" }}>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.props.onClose(false)}
            >
              {"Close\r"}
            </Button>
            <Button
              style={{ marginRight: "8px" }}
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmitConfirm()}
            >
              {"Save\r"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isCloseSaveConfirm || false}
          onClose={() => this.props.onClose(false)}
          PaperComponent={PaperComponent}
          // fullWidth
          maxWidth={"md"}
        >
          <DialogContent>
            <FormControlLabel
              control={<div />}
              label={"Do you want to add a contact?"}
            />
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmit(false)}
            >
              {"No\r"}
            </Button>
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.onSubmit(true)}
            >
              {"Yes\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddUpdateTenant;
